import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { TextPage } from 'legacyComponents/pages/textPage';

import Header from 'apps/components/header/header';

import TermsAndConditions from 'apps/home/terms/t&c.md';
import ChinaTermsAndConditions from 'apps/home/terms/t&c-China.md';
import fetchTextDocument from 'utils/fetchTextDocument';

@observer
export class Terms extends React.Component {
  @observable content = '';

  componentDidMount() {
    const domain = window.location.hostname.split('.').pop();
    const tcFileURL =
      domain === 'cn' ? ChinaTermsAndConditions : TermsAndConditions;
    fetchTextDocument(tcFileURL).then(content => {
      this.content = content;
    });
  }

  render() {
    const __html = this.content;
    return (
      <div>
        <Header />
        <TextPage title='Terms of Service'>
          <div dangerouslySetInnerHTML={{ __html }} />
        </TextPage>
      </div>
    );
  }
}
